function formatTime(t, type, semi) {
    var timeStr = new Date(t).toLocaleString() 
    var arr1 = timeStr.split(" ")
    if (semi == '/') {
      return arr1[0]
    }
    var arr2 = arr1[0].split("/") 
    for(var i = 1; i <= 2; i++) {  
        if(parseInt(arr2[i], 10) < 10) {  
            arr2[i] = "0" + arr2[i]
        }  
    }  
    var str1 = arr2.join("-")
    var arr3 = arr1[1].split(":")
    arr3.splice(2, 1);
    if(arr3[0].indexOf("上午") !== -1) {  
        if(parseInt(arr3[0].replace(/上午/g, ""), 10) < 10) {  
            arr3[0] = "0" + arr3[0].replace(/上午/g, "")
        } else {  
            arr3[0] = arr3[0].replace(/上午/g, "")
        }   
    }  
    if(arr3[0].indexOf("下午") !== -1) {  
        arr3[0] = (12 + parseInt(arr3[0].replace(/下午/g, ""), 10)).toString();  
    }
    var str2 = arr3.join(":")
    if (type == 'date') {
      return str1
    } 
    return str1 + " " + str2
}

function checkConnectLink(link) {
    const regEmail = /[\w!#$ %& '*+/=?^_`{|}~-]+(?:\.[\w!#$%&' * +/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    const regPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    const checkEmail = regEmail.test(link);
    const checkPhone = regPhone.test(link);
    const flag = checkEmail || checkPhone;
    return flag;
}

function getUserInfo() {
    let userInfo = localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : '{}'
    userInfo = JSON.parse(userInfo)
    return userInfo
}

export default {
  formatTime,
  checkConnectLink,
  getUserInfo
};  


// WEBPACK FOOTER //
// ./src/api/util.js